import AjaxUtils from './ajaxUtils';

export const acquireContacts = async contactsData => {
  try {
    return await AjaxUtils.post('/v2/acquired', contactsData);
  } catch (e) {
    return undefined;
  }
};
